import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CUSTOMER_TYPES } from '../../../services/constant';
import { CustomerListComponent } from '../customer-list/customer-list.component';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../../services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss']
})
export class CustomerDetailComponent implements OnInit {
  modal: NgbModalRef;
  parent: CustomerListComponent = null;

  countryList: any[];
  customerTypes = CUSTOMER_TYPES.map(obj => ({label: obj.name, value: obj.value}));
  buyerForm: FormGroup;
  isCreate = true;
  isHeadOffice: Boolean;
  refreshDropdown = false;
  isThailand = true;
  isCountry = 'TH' ;
  errors: any;

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(
    private alertService: AlertService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private translateService: TranslateService,
  ) {}

  open(parent: CustomerListComponent, buyerType, buyer) {
    this.parent = parent;
    this.isCreate = !buyer;
    this.createBuyerForm(buyer);
    this.createValidateCountry();
    this.buyerForm.get('country').valueChanges.subscribe(() => {
      this.adjustCountryValidate();
    });

    this.modal = this.modalService.open(this.modalTemplate, {size: 'lg', centered: true});
  }

  ngOnInit() {
    this.loadCountry();
    this.translateService.onLangChange.subscribe(() => {
      this.translateDropdown();
    });
  }

  get currentLang(): string {
    return this.translateService.currentLang;
  }

  translateDropdown(): void {
    this.refreshDropdown = true;
    setTimeout(() => {
      this.refreshDropdown = false;
    }, 1);
  }

  createBuyerForm(buyer?) {
    this.buyerForm = this.formBuilder.group({
      id: [buyer ? buyer.id : null],
      name: [buyer ? buyer.name : null, Validators.required],
      taxID: [buyer ? buyer.tax_id : null, [this.validateTaxID, Validators.required]],
      branchCode: [buyer ? buyer.branch_code : null, [this.validateBranchCode, Validators.required]],
      branchName: [buyer ? buyer.branch_name : null, Validators.required],
      address: [buyer ? buyer.address : null, Validators.required],
      postCode: [buyer ? buyer.post_code : null, Validators.required],
      country: [buyer ? buyer.country_code : 'TH', Validators.required],
      phoneNumber: [buyer ? buyer.phone_number : null],
      email: [buyer ? buyer.email : null, this.validateEmail],
      ccEmail: [buyer ? buyer.cc_email : null, this.validateCCEmail],
    });
    if (buyer && buyer.branch_name === 'HQ') {
      this.isHeadOffice = true;
    }
  }

  setBuyerHeadOffice() {
    if (this.isHeadOffice) {
      this.branchName.setValue('HQ');
      this.branchCode.setValue('00000');
      this.branchCode.disable();
    } else {
      this.branchName.setValue('');
      this.branchCode.setValue('');
      this.branchCode.enable();
    }
  }

  setHeadOfficeCheckbox(event) {
    this.isHeadOffice = event.target.value === 'HQ';
  }

  createValidateCountry() {
    this.buyerForm.controls['postCode'].setValidators([this.validatePostCode]);
    this.buyerForm.controls['taxID'].setValidators([this.validateTaxID, Validators.required]);
    this.buyerForm.controls['postCode'].updateValueAndValidity();
    this.buyerForm.controls['taxID'].updateValueAndValidity();
  }

  adjustCountryValidate() {
    if (this.buyerForm.get('country').value === 'TH') {
      this.isThailand = true;
      this.buyerForm.controls['postCode'].setValidators([this.validatePostCode]);
      this.buyerForm.controls['taxID'].setValidators([this.validateTaxID]);
    } else {
      this.isThailand = false;
      this.buyerForm.controls['postCode'].setValidators([]);
      this.buyerForm.controls['taxID'].setValidators([this.validateTaxIDOtherCountry]);
    }
    this.buyerForm.controls['postCode'].updateValueAndValidity();
    this.buyerForm.controls['taxID'].updateValueAndValidity();
  }

  validateTaxID(control: AbstractControl): {[key: string]: any} | null  {
    if (control.value && (control.value.length != 13 && control.value.length != 18 && control.value.toLowerCase() != 'n/a')) {
      return { 'taxIDInvalid': true };
    }
    return null;
  }
  validateTaxIDOtherCountry(control: AbstractControl): {[key: string]: any} | null  {
    if (control.value && (control.value.length > 20  && control.value.toLowerCase() !== 'n/a')) {
      return { 'taxIDInvalid': true };
    }
    return null;
  }
  validatePostCode(control: AbstractControl): {[key: string]: any} | null  {
    if (control.value && Boolean(control.value.match(/^[0-9]{5}$/g))) {
      return null;
    }return { postalCodeInvalid: true };
  }

  validateBranchCode(control: AbstractControl): { [key: string]: any } | null {
    if (control.value) {
      if (!Boolean(control.value.match(/^[0-9]{5}$/g))) {
        return {branchCodeInvalid: true}
      }
    } return null
  }

  validateEmail(control: AbstractControl): {[key: string]: any} | null  {
    if (control.value) {
      return Validators.email(control)
    }
    return null;
  }

  validateCCEmail(control: AbstractControl): {[key: string]: any} | null  {
    if (control.value) {
      const emails = control.value.split(",")
      let re = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/
      emails.forEach(email => {
        if (!re.test(email.trim())){
          return {'ccEmailInvalid':re.test(email.trim())}
        }
      });
      return null
    }
    return null;
  }

  loadCountry() {
    this.apiService.getCountry().subscribe(
      (res: any) => {
        this.countryList = res || [];
      },
      (err: HttpErrorResponse) => {
        this.alertService.toastNotify({
          type: 'error',
          text: err.statusText,
          timer: 3000,
        })
      }
    );
  }

  submit() {
    if (this.buyerForm.invalid) {
      return;
    }

    const data = {
      name: this.name.value,
      tax_id: this.taxID.value,
      address: this.address.value,
      branch_code: this.branchCode.value,
      branch_name: this.branchName.value,
      post_code: this.postCode.value,
      country_code: this.country.value,
      email: this.email.value,
      cc_email: this.ccEmail.value
    };

  // get API by operation
    let api = null;
    if (this.isCreate) {
      api = this.apiService.createBuyerBranch(data);
    } else {
      api = this.apiService.updateBuyerBranch(this.id.value, data);
    }

    api.subscribe(
      () => {
        this.modal.close();
        this.sniff('UPDATE_CUSTOMER', data.name);
        this.parent.reloadDropdown();
        this.alertService.toastNotify({
          type: 'success',
          text: this.translateService.instant('SETTINGS.SAVED-SUCCESSFULLY'),
          timer: 2000,
        });
      },
      (err: HttpErrorResponse) => {
        const errorMessage = err.error.detail || err.statusText;
        this.alertService.toastNotify({
          type: 'error',
          text: errorMessage,
          timer: 3000,
        })
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'CUS_INFO',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  get id() {
    return this.buyerForm.get('id');
  }

  get name() {
    return this.buyerForm.get('name');
  }

  get taxID() {
    return this.buyerForm.get('taxID');
  }

  get branchCode() {
    return this.buyerForm.get('branchCode');
  }

  get branchName() {
    return this.buyerForm.get('branchName');
  }

  get address() {
    return this.buyerForm.get('address');
  }

  get postCode() {
    return this.buyerForm.get('postCode');
  }

  get country() {
    return this.buyerForm.get('country');
  }

  get phoneNumber() {
    return this.buyerForm.get('phoneNumber');
  }

  get buyerType() {
    return this.buyerForm.get('buyerType');
  }

  get email() {
    return this.buyerForm.get('email');
  }

  get ccEmail() {
    return this.buyerForm.get('ccEmail');
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-detail/customer-detail.component.ts